module.exports = __webpack_public_path__ + "img/marca4.e1c736c4.jpeg";